import { format, Locale, parse } from "date-fns";

export const formatTime = (
  time: string, // HH:mm (24 hour format)
  locale?: Locale | undefined,
) =>
  format(parse(time, "HH:mm", new Date()), "h:mma", {
    locale,
  }).toLowerCase();
